import React from 'react'
import Button from '../Button'
import Container from '../Container'
import Title from '../Title'
import { useConfig } from '@/hooks'
import { backgroundPattern, evaImage } from '@/images'
import style from './styles/hold.module.scss'

interface IProps {
  title: string
  blueButtonText: string
  redButtonText?: string
}

const WantToHoldChamp = ({
  title,
  blueButtonText,
  redButtonText = 'Памятка участника'
}: IProps): React.ReactElement => {
  const config = useConfig()
  const {
    competition_regulations: competitionRegulations = '',
    manual_chempionat: manualChempionat = ''
  } = config
  return (
    <section className={style.hold}>
      <div
        className={style.hold_bg}
        style={{ backgroundImage: `url(${String(backgroundPattern)})` }}
      >
        <Container className={style.hold_wrap}>
          <img
            src={evaImage}
            width='390px'
            height='403px'
            alt='Ева'
            className={style.hold__image}
          />

          <div className={style.hold_content}>
            <Title type='h2' theme='h3' className={style.hold__title}>
              {title}
            </Title>
            <div className={style.hold_btns}>
              <Button
                size='large'
                wide
                theme='secondary'
                highlight
                href={manualChempionat}
                target='_blank'
                className={style.hold__button}
              >
                {blueButtonText}
              </Button>
              <Button
                size='large'
                wide
                highlight
                href={competitionRegulations}
                target='_blank'
                className={style.hold__button}
              >
                {redButtonText}
              </Button>
            </div>
          </div>
        </Container>
      </div>
    </section>
  )
}

export default WantToHoldChamp
